import * as actionTypes from '../actions/actionTypes'
import { Patient } from "../../models/models";

const initialState = {
    patients: [],
    selected_patient_id: '',
    selected_patient: '',
    patient_details_shown: false
};

const patientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_PATIENTS:
            return {
                ...state,
                patients: []
            };
        case actionTypes.FIND_PATIENTS_SUCCEED:
            return {
                ...state,
                patients: action.payload.map(patient =>
                    Object.assign(new Patient(), patient)
                )
            };
        case actionTypes.SHOW_PATIENT_DETAILS:
            return {
                ...state,
                patient_details_shown: true,
                selected_patient_id: action.payload
            };
        case actionTypes.LOAD_PATIENT_DETAILS_SUCCEED:
            return {
                ...state,
                selected_patient: action.payload,
            };
        case actionTypes.HIDE_PATIENT_DETAILS:
            return {
                ...state,
                patient_details_shown: false,
                selected_patient_id: null,
            };

        default:
            return state
    }
};

export default patientsReducer



// WEBPACK FOOTER //
// ./src/store/reducers/patients.js